
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.444 16H0v-1.6h12.444V16zm-6.222-3.2L.89 8l1.253-1.128 3.191 2.864V0h1.778v9.736l3.191-2.864L11.556 8l-5.334 4.8z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    